import React from 'react'
import './AboutScreen.css';
function AboutScreen() {
    return (
        <div className='aboutscreen'>
            <h2>About</h2>
            <p>Smaill Production</p>
            <p>The Reality</p>
            <h5>Nepal, Kathmandu </h5>
            <p>license:33fce-ff-34rg</p>
            <p>Pan.NO: 0900744</p>
            <p>The real world should end soon.</p>
        </div>
    );
};

export default AboutScreen;
